import { SubRegionCrud } from '@/utils/interfaces'

export const namespaced = true

interface RemittanceState {
  commission: null | SubRegionCrud[]
  data: {
    per_region: []
  }
  remittance: {
    client_origin: {}
    client_destiny: {}
    tariff: {}
  }
}

export const state = {
  commission: null,
  data: {
    per_region: [],
  },
  remittance: {
    client_origin: {},
    client_destiny: {},
    tariff: {},
  },
} as RemittanceState

export const mutations = {
  commission: (
    state: RemittanceState,
    payload: null | SubRegionCrud[],
  ): void => {
    state.commission = payload
  },
  data: (state: RemittanceState, payload: any): void => {
    state.data = payload
  },
  remittance: (state: RemittanceState, payload: any) => {
    state.remittance = Object.assign(state.remittance, payload)
  },
  resetRemittance: (state: RemittanceState) => {
    state.remittance = {
      client_origin: {},
      client_destiny: {},
      tariff: {},
    }
  },
}

export const getters = {
  commission: (state: RemittanceState): null | SubRegionCrud[] =>
    state.commission,
  data: (state: RemittanceState): any => state.data,
  remittance: (state: RemittanceState) => state.remittance,
}

export const actions = {}
